/**
 * Alert State Enum
 * Represents the state of a flow or gate in the alerts API
 */
export enum AlertStateEnum {
  PASSED = 'passed',
  ACTION_REQUIRED = 'action_required',
  IN_REVIEW = 'in_review',
  BLOCKED = 'blocked',
  INFO = 'info',
}
